"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { useContext, useEffect } from "react";
import SSRIcon from "@ingka/ssr-icon";
import checkmark from "@ingka/ssr-icon/paths/checkmark";
import cx from "classnames";
import { ListBoxContext } from "./ListBoxContext";
const MenuItem = (props) => {
  const {
    prefix = "",
    id,
    title,
    quantityLabel,
    leadingIcon,
    disabled = false,
    className,
    onClick,
    ...other
  } = props;
  const ctx = useContext(ListBoxContext);
  const baseClass = `${prefix}menu-item`;
  const classes = cx(
    baseClass,
    disabled && `${baseClass}--disabled`,
    className
  );
  const handleClick = (e) => {
    if (disabled)
      return;
    if (ctx.handleChange)
      ctx.handleChange(id, false);
    if (onClick)
      onClick(e);
  };
  useEffect(() => {
    return () => {
      if (ctx.handleChange)
        ctx.handleChange(id, true);
    };
  }, [id, disabled]);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classes,
      role: "option",
      id,
      "aria-selected": ctx.selectedItems?.includes(id),
      "aria-disabled": disabled,
      onClick: handleClick,
      tabIndex: -1,
      ...other,
      children: [
        leadingIcon && /* @__PURE__ */ jsx("div", { className: `${baseClass}__leading-content`, children: /* @__PURE__ */ jsx(
          SSRIcon,
          {
            prefix,
            className: `${baseClass}__leading-icon`,
            paths: leadingIcon
          }
        ) }),
        /* @__PURE__ */ jsx("div", { className: `${baseClass}__title`, children: title }),
        quantityLabel && /* @__PURE__ */ jsx("div", { className: `${baseClass}__trailing-content`, children: quantityLabel }),
        ctx.selectedItems?.includes(id) && /* @__PURE__ */ jsx(
          SSRIcon,
          {
            prefix,
            paths: checkmark,
            className: `${baseClass}__selected-icon`
          }
        )
      ]
    }
  );
};
var MenuItem_default = MenuItem;
export {
  MenuItem_default as default
};
